// extracted by mini-css-extract-plugin
export default {"header":"styles_header__wLGL6","footer":"styles_footer__bgob6","content":"styles_content__g4GGR","position":"styles_position__7nobo"};